import { bind } from 'bind-decorator';
import { createBrowserHistory, createMemoryHistory } from 'history';
import z from 'z';

class History {
  browserHistory: any;

  constructor() {
    if (process.env.SSR === 'true' || process.env.NODE_ENV === 'jsdom') {
      this.browserHistory = createMemoryHistory();
    } else {
      this.browserHistory = createBrowserHistory();
    }
    window.browserHistory = this.browserHistory;
  }

  get location() {
    return this.browserHistory.location;
  }

  @bind
  push(route: string, query?: any, force?: boolean) {
    let path = this.sanitize(route);
    if (!force && this.location.pathname === path) {
      return;
    }
    this.browserHistory.push(path);
  }

  @bind
  replace(route: string, force?: boolean) {
    let path = this.sanitize(route);

    if (!force && this.location.pathname === path) {
      return;
    }
    this.browserHistory.replace(path);
  }

  @bind
  goBack() {
    return this.browserHistory.goBack();
  }

  private sanitize(route: string) {
    let _route = route.replace(/^\\|^\//, '');
    return z.format(`/${_route}`);
  }

  @bind
  clean() {
    this.browserHistory.replace(this.location.pathname);
  }
}
export const history = new History();
export default history;
